import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Seleziona i moduli", -1)
const _hoisted_3 = { class: "my-2" }
const _hoisted_4 = { class: "scrollListContainer" }
const _hoisted_5 = { class: "d-flex pointer" }
const _hoisted_6 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary ml-1",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectAll && _ctx.selectAll(...args)))
      }, " Seleziona tutti "),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary ml-1",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.tutor && _ctx.tutor(...args)))
      }, " Tutor "),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary ml-1",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.networker && _ctx.networker(...args)))
      }, " Networker "),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary ml-1",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.centroFumo && _ctx.centroFumo(...args)))
      }, " Centro fumo "),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.search) = $event)),
          placeholder: "Cerca..."
        }, null, 512), [
          [_vModelText, _ctx.search]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredModules, (item, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "scrollListItem",
          key: i
        }, [
          _createElementVNode("label", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localValue) = $event)),
              value: item.id
            }, null, 8, _hoisted_6), [
              [_vModelCheckbox, _ctx.localValue]
            ]),
            _createTextVNode(" " + _toDisplayString(item.label) + " (" + _toDisplayString(item.id) + ") ", 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}